<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <h2>Grape Lists</h2>
      <div class="list-wrap pure-g">
        <div class="pure-u-1-4 list-actions">
          <div class="pure-form pure-form-stacked">
            <div class="input-field">
              <input name="new_list" placeholder="New list" id="new_list" type="text" class="validate tooltip" v-model="newListName" autocomplete="off" v-on:keyup.enter="createList">
              <div v-on:click="createList" class="add-list-trigger"><i class="fal fa-plus-circle"></i><i class="fas fa-circle-notch fa-spin"></i></div>
            </div>
          </div>
          <div class="pure-form pure-form-stacked">
            <label>List select</label>
            <select name="list_select" id="list_select" v-on:change="listChange()">
              <option v-for="list in lists" :value="list.id">{{list.name}}</option>
            </select>
          </div>

          <div class="pure-form pure-form-stacked random-grapes-form">
            <label>Add random grapes to list</label>
            <input name="add_random_grapes" placeholder="Number of Grapes" id="add_random_grapes" type="text" class="validate" v-model="randomGrapesNumber" autocomplete="off">
            <button v-on:click="generateRandomGrapes">Add Grapes</button>
          </div>

          <h4>Grape results</h4>
          <ais-index app-id="I3X2NRWKV7" api-key="14d790560a425143a61099fd78bc9104" index-name="grapes">
            <ais-search-box></ais-search-box>
            <ais-results>
              <template slot-scope="{ result }">
                <div class="grape-result" v-on:click="addGrapeToCurrentList(result.id, result.grapeTitle)">
                  <div class="author">{{result.sourceAuthor}}</div>
                  <div class="source">{{result.grapeSource}}</div>
                  <ais-highlight :result="result" attribute-name="grapeTitle"></ais-highlight>
                </div>
              </template>
            </ais-results>
          </ais-index>
        </div>
        <div class="pure-u-3-4 grape-results">
          <div class="table-wrap">
            <HotTable :root="root" ref="grapesTable" :settings="hotSettings" :onAfterRowMove="afterRowMoveHandler"></HotTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* global $, algoliasearch */
  import HotTable from 'vue-handsontable-official'
  import firebase from 'firebase'
  import db from '../firebaseInit'
  import Request from 'superagent'
  import 'vuejs-noty/dist/vuejs-noty.css'
  const crypto = require('crypto');

  export default {
    data: function () {
      return {
        root: 'grapes-table',
        currentUserID: null,
        userIsAdmin: this.$globals.userRole == 'admin',
        currentList: null,
        grapes: [],
        grapeIDs: [],
        lists: [],
        mailchimpLists: [],
        newListName: null,
        isAddingList: false,
        grapesQuery: '',
        searchLimit: 200,
        pageLimit: 5000,
        randomGrapesNumber: '',
        randomGrapes: [],
        hotSettings: {
          data: this.grapes,
          rowHeaders: true,
          contextMenu: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          manualRowMove: true,
          colHeaders: ['Remove', 'ID', 'Author', 'Title', 'Length', 'Source', 'Publish Year', 'Mailchimp Campaigns', 'Twitter Campaigns', 'Username', 'Updated'],
          rowHeights: 50,
          colWidths: [150, 50, 150, 220, 80, 150, 100, 160, 160, 110, 160],
          columns: [
            {data: 'remove', renderer: 'html'},
            {data: 'id', readOnly: true, type: 'text'},
            {data: 'sourceAuthor', readOnly: true, type: 'text'},
            {data: 'grapeTitle', readOnly: true, type: 'text'},
            {data: 'grapeLength', readOnly: true, type: 'numeric'},
            {data: 'grapeSource', readOnly: true, type: 'text'},
            {data: 'grapeOriginalPublishYear', type: 'numeric'},
            {data: 'mailchimpCampaignCount', type: 'numeric'},
            {data: 'twitterCampaignCount', type: 'numeric'},
            {data: 'grapeUsername', readOnly: true, type: 'text'},
            {data: 'updatedTimestamp', readOnly: true, type: 'date'}
          ]
        }
      }
    },
    name: 'listsAdmin',
    components: {
      HotTable
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.userLoggedIn = true
        } else {
          vm.userLoggedIn = false
        }
      })
      vm.$globals.isAdmin = true
      vm.showLoading()
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.currentUserID = user.uid
          vm.getLists()
          vm.getGrapes()
        }
      })
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      createList: function () {
        let vm = this
        if (this.newListName && this.newListName.length < 3) {
          return
        }
        if (!vm.isAddingList && this.newListName.length >= 3) {

          vm.isAddingList = true
          let listName = this.newListName
          let userID = this.currentUserID
          $('#new_list').prop('disabled', true)
          $('.add-list-trigger').addClass('is-adding')
          let listData = {
            'name': listName,
            'userID': userID,
            'grapes': [],
            'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
          }
          mixpanel.track(
            'Created list',
            {
              'listName': listName
            }
          )
          db.collection('lists').add(listData).then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.newListName = ''
            vm.getLists()
            setTimeout(function () {
              vm.isAddingList = false
              $('#new_list').prop('disabled', false)
              $('.add-list-trigger').removeClass('is-adding')
            }, 500)
          })
        }
      },
      getLists: function () {
        let vm = this
        var listsRef = db.collection('lists')
        listsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var listData = doc.data()
            listData.id = doc.id
            if (!vm.checkPresentInArray(vm.lists, listData.id, true)) {          
              vm.lists.push(listData)
            }
          })
          setTimeout(function () {
            vm.hideLoading()
            vm.listChange()
          }, 1000)
        })
      },
      listChange: function () {
        let vm = this
        let $listID = $('#list_select').val()
        vm.showLoading()
        console.log('list changed: ' + $listID)
        vm.grapeIDs = []
        vm.grapes = []
        vm.$refs.grapesTable.table.loadData(vm.grapes)
        var listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          vm.grapeIDs = doc.data().grapes
          vm.getGrapes()
          vm.hideLoading()
        })
      },
      checkPresentInArray: function (inArr, ID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === ID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      getGrapes: function () {
        console.log('getting list grapes')
        let vm = this
        let regex = /\s+/gi
        if (vm.grapeIDs === undefined || vm.grapeIDs.length == 0) {
          vm.$refs.grapesTable.table.loadData(vm.grapes)
        } else {
          vm.grapeIDs.forEach(grapeID => {
            db.collection('grapes').where('id', '==', grapeID).get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                var grapeData = doc.data()
                grapeData.docID = doc.id
                grapeData.grapeLength = grapeData.grapeContent.trim().replace(regex, ' ').split(' ').length
                grapeData.remove = '<a href="#" data-id="' + doc.id + '" data-grape-id="' + grapeID + '" class="remove-grape">Remove</a>'
                if (!vm.checkPresentInArray(vm.grapes, grapeData.id, true)) {          
                  vm.grapes.push(grapeData)
                }
              })
              /* Load Data */
              console.log('loading table')
              vm.$refs.grapesTable.table.loadData(vm.grapes)
              setTimeout(function () {
                vm.hideLoading()
              }, 1000)
            })
          })
        }
      },
      addGrapeToCurrentList: function (grapeID, grapeName) {
        let vm = this
        let $listID = $('#list_select').val()
        let listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var grapes = doc.data().grapes
            if ($.inArray(grapeID, grapes) === -1) {
              grapes.push(grapeID)
              listRef.update({
                grapes: grapes
              }).then(function() {
                console.log('grape successfully added to list: ' + grapeID)
                vm.$noty.success(grapeName + ' added to list')
                vm.grapeIDs = grapes
                vm.getGrapes($listID)
              })
              .catch(function(error) {
                console.error("Error writing document: ", error);
              });
            }
          }
        })
      },
      removeGrapeFromList: function (docID, grapeID) {
        let vm = this
        let $listID = $('#list_select').val()
        console.log('removeGrapeFromList, list: ' + $listID + ', grapeID: ' + grapeID + ', docID: ' + docID)
        let listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var grapes = doc.data().grapes
            console.log(grapes)
            if ($.isArray(grapes)) {
              grapes.splice($.inArray(grapeID, grapes), 1)
              listRef.update({
                grapes: grapes
              })
              vm.grapeIDs = grapes
              vm.grapes = []
              vm.getGrapes($listID)
            }
          }
        })
      },
      updateList: function (grapeIDs) {
        let vm = this
        let $listID = $('#list_select').val()
        let listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            listRef.update({
              grapes: grapeIDs
            }).then(function() {
              console.log("List grapes successfully updated!");
            })
            .catch(function(error) {
              console.error("Error writing document: ", error);
            });
            console.log('updatedGrapeList')
          }
        })
      },
      addRandomGrapes: function () {
        let vm = this
        let $listID = $('#list_select').val()
        let listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var grapes = doc.data().grapes
            for (var i = 0; i < vm.randomGrapes.length; i++) {
              var grape = vm.randomGrapes[i]
              if ($.inArray(grape, grapes) === -1) {
                grapes.push(grape)
              }
            }
            listRef.update({
              grapes: grapes
            }).then(function() {
              vm.$noty.success(vm.randomGrapesNumber + ' random grapes added to list')
              vm.grapeIDs = grapes
              vm.getGrapes($listID)
            })
            .catch(function(error) {
              console.error("Error writing document: ", error);
            });           
          }
        })
      },
      generateRandomGrapes: function () {
        let vm = this
        var total = parseInt(vm.randomGrapesNumber, 10)
        vm.showLoading()
        vm.randomGrapes = []
        console.log('getRandomGrapes: ' + total)
        for (var i = 0; i < total; i++) {
          var random = crypto.randomBytes(4).readUInt32BE(0, true) + crypto.randomBytes(4).readUInt32BE(0, true)
          let grapesRef = db.collection('grapes')
          var queryRef = grapesRef.where('random', '>', random).orderBy('random').limit(1)
          queryRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.exists && $.inArray(doc.data().id, vm.randomGrapes) === -1) {
                var grapeID = doc.data().id
                if ($.inArray(grapeID, vm.randomGrapes) === -1) {
                  vm.randomGrapes.push(grapeID)
                }
              } else {
                queryRef = grapesRef.where('random', '<=', random).orderBy('random', 'desc').limit(1)
                queryRef.get().then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                      var grapeID = doc.data().id
                      if ($.inArray(grapeID, vm.randomGrapes) === -1) {
                        vm.randomGrapes.push(grapeID)
                      }
                    }
                  })
                })
              }
            })
          })
          if (i + 1 == total) {
            console.log('finished getRandomGrapes')
            console.log(vm.randomGrapes)
            vm.addRandomGrapes()
            setTimeout(function () {
              vm.hideLoading()
            }, 1000)
            setTimeout(function () {
              vm.isLoading = false
            }, 2000)
          }
        }
      },
      checkGrapePresent: function (inArr, grapeID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapeID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      afterRowMoveHandler: function (rows, target) {
        console.log('afterRowMoveHandler')
        let vm = this
        let data = this.$refs.grapesTable.table.getData()
        console.log(data)
        let revisedGrapeIDs = []
        for (let i = 0; i < data.length; i++) {
          let grapeID = data[i][1]
          revisedGrapeIDs.push(grapeID) 
        }
        vm.updateList(revisedGrapeIDs)
      }
    },
    mounted () {
      let $vue = this
      $(document).on('click', '.remove-grape', function () {
        $vue.removeGrapeFromList($(this).data('id'), $(this).data('grape-id'))
        return false
      })
    }
  };
</script>

<style>
  .ais-index form {
    position: relative;
  }
  .ais-index form button {
    position: absolute;
    top: 0;
    right: 0;
    height: 36px;
    width: 36px;
  }
  .ais-index form button[type="submit"] {
    right: 36px;
  }
  .ais-highlight em {
    text-decoration: underline;
    font-weight: bold;
  }
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
  }
  .input-field {
    position: relative;
    margin-bottom: 20px;
  }
  .add-list-trigger {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -9px;
    cursor: pointer;
  }
  .add-list-trigger i.fa-circle-notch {
    display: none;
  }
  .add-list-trigger.is-adding i {
    display: none;
  }
  .add-list-trigger.is-adding i.fa-circle-notch {
    display: inline-block;
  }
  .list-wrap {
    text-align: left;
    max-width: 96%;
    margin: 0 auto 100px;
  }
  .list-wrap .pure-form label {
    font-weight: bold;
    line-height: 30px
  }
  .list-wrap .pure-form select, .list-wrap .pure-form input {
    width: 100%;
  }
  .list-wrap form input[type="search"] {
    line-height: 30px;
    width: 100%;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .list-actions {
    padding-right: 20px;
    box-sizing: border-box;
  }
  .list-actions h4 {
    border-bottom: 1px solid #2c3e50;
    padding: 0 0 4px;
    margin: 30px 0 20px;
    line-height: 30px;
  }
  .grape-results {
    padding-left: 20px;
    box-sizing: border-box;
  }
  .ais-results {
    font-size: 0.8em;
    width: 100%;
    display: table-row-group;
  }
  .ais-results > div {
    display: table-row;
  }
  .ais-results:hover > div {
    opacity: 0.5;
  }
  .ais-results > div:hover {
    opacity: 1;
    cursor: pointer;
  }
  .grape-result .source {
    padding: 10px 15px 10px 0;
    float: left;
    width: 30%;
    box-sizing: border-box;
    display: table-cell;
    vertical-align: middle;
  }
  .grape-result .author {
    padding: 10px 15px 10px 0;
    float: left;
    width: 30%;
    box-sizing: border-box;
    display: table-cell;
    vertical-align: middle;
  }
  .grape-result > span {
    padding: 10px 0;
    float: left;
    width: 40%;
    box-sizing: border-box;
    display: table-cell;
    vertical-align: middle;
  }
  .table-wrap {
    max-width: 100%;
    margin: 0 auto;
  }
  #grapes-table {
    width: 100%;
    height: 800px;
    margin-top: 4px;
    overflow: hidden;
  }
  #grapes-table th {
    vertical-align: middle;
  }
  #grapes-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #grapes-table thead th .relative {
    padding: 4px 8px;
  }
  .random-grapes-form {
    margin-top: 15px;
    clear: both;
    height: auto;
    overflow: hidden;
  }
  .list-wrap .random-grapes-form input#add_random_grapes {
    width: 58%;
    float: left;
    margin: 0;
  }
  .random-grapes-form button {
    width: 40%;
    float: right;
    height: 37px;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/listsAdmin.vue